import React from 'react'
import ReviewStore from './store/ReviewStore'
import ReviewList from './components/reviewList'
import { Subscribe } from 'unstated'
import CourseStore from '../../../../../../../../../Store/CourseStore'

const Reviews = () => {
  return (
    <Subscribe to={[CourseStore]}>
      {({ state: courseData }) => {
        return (
          <ReviewStore.Provider initialState={courseData}>
            <ReviewList />
          </ReviewStore.Provider>
        )
      }}
    </Subscribe>
  )
}

export default Reviews
